import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethod,
} from '@reverbdotcom/commons/src/gql/graphql';
import experiments from '@reverbdotcom/commons/src/experiments';

export function useEventTracker({ listingCurrency, parentComponentName, currency, quantity = null, amountCents = null, paymentMethods }: {
  listingCurrency: string,
  parentComponentName: string,
  currency: string,
  quantity?: number,
  amountCents?: number,
  paymentMethods?: CheckoutPaymentMethod[],
}) {
  const user = useUser();
  const tracked = [];

  if (paymentMethods?.includes(CheckoutPaymentMethod.PAYPAL)) {
    tracked.push(experiments.STANDALONE_PAYPAL);
  }

  const customTrackedValues = {
    parentComponentName,
    buyerCurrency: user.currency,
    listingCurrency,
    currency,
    quantity,
    amountCents,
  };
  function trackPaypalEvent(eventName: MParticleEventName) {
    trackEvent({
      eventName,
      experiments: formatExperimentsForEventAttributes(user, tracked),
      ...customTrackedValues,
    });
  }

  return trackPaypalEvent;
}
